import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ENVIRONMENT } from '../../../../environments/environment.interface';
import { FilesQuery } from '../../../api/api-types/document.api';
import { ClientDocumentsResponse, DocumentFile } from '../../../api/app-types/document.app';
import { UPLOAD_API } from '../../../api/services/upload.api';
import { LocalStorageService } from '../../storage/local-storage.service';

const resolveInitialPageSize = (
	storage: LocalStorageService,
	auth: MsalService | null,
	preferenceKey: string,
	defaultPageSize: number,
	pageSizeOptions: number[],
) => {
	const userId = storage.resolveCurrentUserId(auth);
	if (!userId) return defaultPageSize;

	const saved = storage.getPageSize(userId, preferenceKey);
	return saved && pageSizeOptions.includes(saved) ? saved : defaultPageSize;
};

export const clientDocumentsResolver: ResolveFn<ClientDocumentsResponse> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(UPLOAD_API);
	const env = inject(ENVIRONMENT);
	const storage = inject(LocalStorageService);
	const auth = inject(MsalService, { optional: true });
	const clientId = Number(route.params['id']);
	const initialRange = resolveInitialPageSize(
		storage,
		auth,
		'documents-list',
		env.defaultPageSize,
		env.pageSizeOptions,
	);
	const fileQuery: FilesQuery = {
		assignment: true,
		contact: true,
		disabilityKind: true,
		disabilityReport: true,
		report: true,
		offset: 0,
		range: initialRange,
	};
	return await api.getClientFiles(clientId, fileQuery);
};

export const documentResolver: ResolveFn<DocumentFile> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(UPLOAD_API);
	const documentId = route.params['documentId'];
	return await api.getDocument(documentId);
};
